import {reInitScripts} from "../../utils/re-init-scripts";
import notifier from "../notifier";
import {declOfNum} from "../../utils/decl-of-num";
import 'timepicker/jquery.timepicker.min';
import 'timepicker/jquery.timepicker.min.css';

function init(element) {
    const translates = window.translates.logic;
    const $container = $('[data-pick-up]');
    const $body = $('body');
    const $cityId = $(element).find('[name="cityId"]');
    const $organizationNameOrder = $(element).find('[name="organizationNameOrder"]');
    const $contactPhoneOrder = $(element).find('[name="contactPhoneOrder"]');
    const $contactPersonOrder = $(element).find('[name="contactPersonOrder"]');
    const $emailOrder = $(element).find('[name="emailOrder"]');
    const $addressOrder = $(element).find('[name="addressOrder"]');
    const $typeCargo= $(element).find('[name="typeCargo"]');
    const $needAuto = $(element).find('[name="needAdditionalAutoCheck"]');
    const $negabarit = $(element).find('[name="negabarit"]');
    const $timeFromOrder = $container.find('[name="timeFromOrder"]');
    const $timeToOrder = $container.find('[name="timeToOrder"]');
    const $warehouseId = $container.find('.is-active-warehouse [name="warehouseId"]');
    const $cityWarehouseId = $container.find('.is-active-warehouse [name="cityWarehouseId"]');
    const $economyPickUp = $(element).find('[name="economyPickUp"]');
    const $dateOrder = $container.find('[name="dateOrder"]');
    const $cargoCommentBlock= $(element).find('[data-cargo-comment-block]');
    const $totalSum = $('[data-total-sum]');
    const $wrapper = $('[data-tariff-wrapper]');
    const $needDelivery = $(element).find('.is-active-warehouse [id="need-delivery"]');
    const $deliveryAddress = $(element).find('.is-active-warehouse [id="delivery-address"]');

    let fromArr, toArr;

    let limitWeight = 100;
    let limitVolume = 0.5;
    let listPallets = [];

    let pickUpSum = {
        'tariffCost': {
            "weight": null,
            "volume": null,
            "places": null,
            "palletId": true,
            "cityId": null,
            "cost": null,
            "tarifName": null,
            "needAuto": false,
            "isPick": true,
            "hydroB": false,
            "isNegabarit": false,
            "numReceipts": null,
        }
    };

    let pickData = {
        "AppNumber": null,
        "AdditionalPackingOrderCheck": false,
        "AdditionalComment": null,
        "WeightCargoOrder": null,
        "VolumeCargoOrder": null,
        "declaredCost": null,
        "payForPickUpCargo3drName": null,
        "payForPickUpCargo": 0,
        "pickUpCargoExtended": [],
        "IsAutoOrder": false,
        "MondayAutoOrder": false,
        "TuesdayAutoOrder": false,
        "WednesdayAutoOrder": false,
        "ThursdayAutoOrder": false,
        "FridayAutoOrder": false,
        "SaturdayAutoOrder": false,
        "DateOrder": null,
        "TimeFromOrder": null,
        "TimeToOrder": null,
        "AddressOrder": null,
        "ContactPersonOrder": null,
        "ContactPhoneOrder": null,
        "EmailOrder": null,
        "CargoSizeOrder": 0,
        "CargoSizeOrderCheck": false,
        "IsPallet": false,
        "PalletComment": null,
        "CommentOrder": null,
        "NeedAdditionalAuto": null,
        "NeedAdditionalAutoCheck": false,
        "CityId": null,
        "OrganizationNameOrder": null,
        "NoCallBack": false,
        "documentsStr": null,
        "documentsName": null
    };

    $(document).on('click', '[data-create-pick]', function () {
        createPickUp();
    });

    $(document).on('click', '[data-create-pick-step2]', function () {
        setButtonsState();
        createPickUp(true);
    });

    $(document).on('click', '[data-pick-sum]', function () {
        if($wrapper.find('[data-tariff-item]').hasClass('is-valid')) {
            pickUpCost();
        } else {}
    });

    $(document).on('click', '[data-add-tariff]', function () {
        if ($(this).hasClass('is-active')) {
            const $currentTemplate = $(this).parents('[data-tariff-item]');
            const $containerTariff = $('[data-tariff-wrapper]');
            const data = setTariffData($currentTemplate);
            const $currentTemplateCollapsed = $currentTemplate.find('[data-tariff-collapsed]');
            const template = $($('#cargoItem').html());
            let type = $('.is-active-tariff').find('[name="typeCargo"] option:selected').val();
            let $template = $(template);
            $containerTariff.find('[data-tariff-item]').first().addClass('is-active-tariff');
            $currentTemplateCollapsed.find('[data-tariff-counter]').text($containerTariff.children().length);
            $containerTariff.prepend($template);
            $template.find('[data-tariff-form] [data-tariff-counter]').text($containerTariff.children().length);
            $template.attr('id', 'tariff-' + parseInt($containerTariff.children().length));
            if(type === 'cargo') {
                $template.find('[data-tariff-form] [name="typeCargo"]').attr('disabled', true);
            } else if (type === 'pallets'){
                $template.find('[name="typeCargo"] option[value="pallets"]').prop('selected', true);
                $template.find('[name="typeCargo"]').attr('disabled', true);
                $template.find('[data-type-pallets]').removeClass('_hide');
                $template.find('[data-type-cargo]').find('input, select').attr('disabled', true);
            }
            $template.addClass('is-active-tariff');
            updateTariffInfo($currentTemplate, data);
            eventsCargo();
            setButtonsState();
            reInitScripts($template[0]);
        }
    });

    $(document).on('click', '[data-edit-tariff]:not(.disabled)', function () {
        const $button = $(this);
        const $buttons = $(element).find('[data-edit-tariff]');
        $buttons.not($button).addClass('disabled');
        const $tariff = $button.parents('[data-tariff-item]');
        $tariff.removeClass('saved');
        setButtonsState();
        $('.is-active-tariff').removeClass('is-active-tariff');
        $tariff.addClass('is-active-tariff is-editable');
        $tariff.find('[data-tariff-collapsed]').addClass('_hide');
        $tariff.find('[data-tariff-form]').removeClass('_hide');
        $('.is-editable').find('[name="typeCargo"]').attr('disabled', true);
    });

    $(document).on('click', '.is-active-tariff [data-save-tariff]', function () {
        const $buttons = $(element).find('[data-edit-tariff]');
        const $wrapper = $('[data-tariff-wrapper]');
        const $currentTemplate = $(this).parents('[data-tariff-item]');
        const data = setTariffData($currentTemplate);
        $buttons.removeClass('disabled');
        $wrapper.find('[data-tariff-item]').first().addClass('is-active-tariff');
        updateTariffInfo($currentTemplate, data);
        setButtonsState();
    });

    $(document).on('click', '[data-remove-tariff]', function () {
        $(this).parents('[data-tariff-item]').remove();
        $('[data-tariff-wrapper]').children().each((index, item) => {
            $(item).find('[data-tariff-counter]').text($('[data-tariff-wrapper]').children().length - index);
        });
        $('[data-tariff-item]').find('[data-tariff-form] [name="typeCargo"]').attr('disabled', false);
        setButtonsState();
    });

    $(document).on('click', '[data-warehouse-add]', function () {
        if ($(this).hasClass('is-active')) {
            const $currentTemplate = $(this).parents('[data-warehouse-item]');
            const $containerTariff = $('[data-warehouse-wrapper]');
            const data = setWarehouseData($currentTemplate);
            const $currentTemplateCollapsed = $currentTemplate.find('[data-warehouse-collapsed]');
            const template = $($('#warehouseItem').html());
            let $template = $(template);
            $containerTariff.find('[data-warehouse-item]').first().addClass('is-active-warehouse');
            $currentTemplateCollapsed.find('[data-warehouse-counter]').text($containerTariff.children().length);
            $containerTariff.prepend($template);
            $template.find('[data-warehouse-form] [data-warehouse-counter]').text($containerTariff.children().length);
            $template.attr('id', 'warehouse-' + parseInt($containerTariff.children().length));
            //setWarehouseParametersByGeneral($template);
            updateWarehouseInfo($currentTemplate, data);
            $template.addClass('is-active-warehouse');
            eventsWarehouse();
            setButtonsStateStep2();
            reInitScripts($template[0]);
        }
    });

    $(document).on('click', '[data-warehouse-remove]', function () {
        $(this).parents('[data-warehouse-item]').remove();
        $('[data-warehouse-wrapper]').children().each((index, item) => {
            $(item).find('[data-warehouse-counter]').text($('[data-warehouse-wrapper]').children().length - index);
        });
        setButtonsStateStep2();
    });

    $(document).on('click', '[data-edit-warehouse]:not(.disabled)', function () {
        const $button = $(this);
        const $buttons = $(element).find('[data-edit-warehouse]');
        $buttons.not($button).addClass('disabled');
        const $tariff = $button.parents('[data-warehouse-item]');
        $tariff.removeClass('saved');
        $('.is-active-warehouse').removeClass('is-active-warehouse');
        $tariff.addClass('is-active-warehouse is-editable');
        $tariff.find('[data-warehouse-collapsed]').addClass('_hide');
        $tariff.find('[data-warehouse-form]').removeClass('_hide');
        setButtonsStateStep2();
    });

    $(document).on('click', '.is-active-warehouse [data-save-warehouse]', function () {
        const $buttons = $(element).find('[data-edit-warehouse]');
        const $wrapper = $('[data-warehouse-wrapper]');
        const $currentTemplate = $(this).parents('[data-warehouse-item]');
        const data = setWarehouseData($currentTemplate);
        $buttons.removeClass('disabled');
        $wrapper.find('[data-warehouse-item]').first().addClass('is-active-warehouse');
        updateWarehouseInfo($currentTemplate, data);
        setButtonsStateStep2();
    });

    $(document).on('change', '.is-active-warehouse #need-delivery', function () {
        if (this.checked) {
            $(element).find('.is-active-warehouse [id="delivery-address"]').removeClass('_hide');
            $(element).find('.is-active-warehouse [id="address"]').attr('data-required', '').attr('data-fields', '');
        }
        else {
            $(element).find('.is-active-warehouse [id="delivery-address"]').addClass('_hide');
            $(element).find('.is-active-warehouse [id="address"]').removeAttr('data-required').removeAttr('data-fields');
        }
    })

    $(document).on('click', '[data-pick-up] [data-tabs-button="step2"]', function () {
        const $containerTariff = $('[data-warehouse-wrapper]');
        setWarehouseParametersByGeneral($containerTariff);
        $totalSum.text('0,00');
    })

    function setEvents() {
        $(document).on('click', '.is-active-tariff [data-cargo-comment-button]', function () {
            if($cargoCommentBlock.hasClass('_hide')){
                $cargoCommentBlock.removeClass('_hide');
            } else {
                $cargoCommentBlock.addClass('_hide');
            }
        });

        $(document).on('change', '[data-fields]', function () {
            setButtonsState();
        });

        $(document).on('select2:select', '.is-active-tariff [name="typeCargo"]', function () {
            let type = this.value;
            if (type === 'pallets') {
                pickData['IsPallet'] = true;
            } else {
                pickData['IsPallet'] = false;
            }
        });

        $(document).on('select2:select', '[name="cityId"]', function () {
            pickData['CityId'] = this.value;
            pickUpSum['tariffCost']['cityId'] = this.value;
            HasWarehouseInCity(this.value);
        });

        $(document).on('change', '[name="weightPalletsOrder"]', function () {
            pickUpSum['tariffCost']['weight'] = this.value;
        });

        $(document).on('change', '[name="placesPalletsOrder"]', function () {
            pickUpSum['tariffCost']['places'] = this.value;
        });

        $(document).on('select2:select', '[name="palleteType"]', function () {
            let $palleteType = this.value;

            if($palleteType === '1') {
                pickUpSum['tariffCost']['palletId'] = true;
            }else if ($palleteType === '2' || $palleteType === '3') {
                pickUpSum['tariffCost']['palletId'] = false;
            }
        });

        $(document).on('change', '[name="NoCallBack"]', function () {
            pickData['NoCallBack'] = this.checked;
        });

        $(document).on('change', '[name="organizationNameOrder"]', function () {
            pickData['OrganizationNameOrder'] = this.value;
        });

        $(document).on('change', '[name="commentOrder"]', function () {
            pickData['CommentOrder'] = this.value;
        });

        $(document).on('change', '[name="negabarit"]', function () {
            pickData['CargoSizeOrderCheck'] = this.checked;
        });

        $(document).on('change', '[name="payerTypes"]', function () {
            pickData['payForPickUpCargo'] = this.value;
        });

        $(document).on('change', '[name="needAdditionalAutoCheck"]', function () {
            pickData['NeedAdditionalAutoCheck'] = this.value;
        });

        $(document).on('change', '[name="additionalComment"]', function () {
            pickData['AdditionalComment'] = this.value;
        });

        $(document).on('change', '[name="additionalPackingOrderCheck"]', function () {
            pickData['AdditionalPackingOrderCheck'] = this.value;
        });

        $(document).on('change', '[name="payForPickUpCargo3drName"]', function () {
            pickData['payForPickUpCargo3drName'] = this.value;
        });

        $(document).on('change', '[name="declaredCost"]', function () {
            pickData['declaredCost'] = this.value;
        });

        $(document).on('change', '[name="contactPhoneOrder"]', function () {
            pickData['ContactPhoneOrder'] = this.value;
        });

        $(document).on('change', '[name="contactPersonOrder"]', function () {
            pickData['ContactPersonOrder'] = this.value;
        });

        $(document).on('change', '[name="dateOrder"]', function () {
            pickData['DateOrder'] = this.value;
            getTimeIntervals();
        });

        $(document).on('change', '[name="emailOrder"]', function () {
            pickData['EmailOrder'] = this.value;
        });

        $(document).on('change', '[name="addressOrder"]', function () {
            pickData['AddressOrder'] = this.value;
        });

        $(document).on('change', '[name="documents"]', function (evt) {
            let reader = new FileReader();
            //const name = this.value.split('\\').pop();
            pickData['documentsName'] = this.value.split('\\').pop();
            //let fileName = name;
            reader.onload = function (e) {
                pickData['documentsStr'] = e.target.result;
                /*namePdf.text(name)
                loadedPdf.removeClass('_hide');
                unLoadedPdf.addClass('_hide');*/
            };
            reader.readAsDataURL(evt.target.files[0]);
        });

        $(document).on('change', '[name="weightCargoOrder"]', function () {
            let weightLimitMax = 99999.99;
            let weightLimitMin = 0.1;

            if (this.value > weightLimitMax) {
                $('.is-active-tariff [name="weightCargoOrder"]').val(weightLimitMax);
            } else if (this.value === '0') {
                $('.is-active-tariff [name="weightCargoOrder"]').val(weightLimitMin);
            }
            this.value  > limitWeight ? $economyPickUp.prop('checked', false).prop('disabled', true) : $economyPickUp.prop('disabled', false);
            pickUpSum['tariffCost']['weight'] = this.value;
            pickData['WeightCargoOrder'] = this.value;
        });

        $(document).on('change', '[name="volumeCargoOrder"]', function () {
            let volumeLimitMax = 120;
            let volumeLimitMin = 0.1;

            if (this.value > volumeLimitMax) {
                $('.is-active-tariff [name="volumeCargoOrder"]').val(volumeLimitMax);
            } else if (this.value === '0') {
                $('.is-active-tariff [name="volumeCargoOrder"]').val(volumeLimitMin);
            }
            this.value  > limitVolume ? $economyPickUp.prop('checked', false).prop('disabled', true) : $economyPickUp.prop('disabled', false);

            pickData['VolumeCargoOrder'] = this.value;
            pickUpSum['tariffCost']['volume'] = this.value;
        });


        $(document).on('change', '[name="placesCargoOrder"]', function () {
            pickData['PlacesCargoOrder'] = this.value;
            pickUpSum['tariffCost']['places'] = this.value;
        });

        $(document).on('select2:select', '[name="timeFromOrder"]', function () {
            pickData['TimeFromOrder'] = this.value;
            getTimeIntervals(null, $(this).find('option:selected').text());
        });

        $(document).on('select2:select', '[name="timeToOrder"]', function () {
            pickData['TimeToOrder'] = this.value;
        });

        $(document).on('change', '[name="SaturdayAutoOrder"]', function () {
            pickData['SaturdayAutoOrder'] = this.checked;
        });

        $(document).on('change', '[name="FridayAutoOrder"]', function () {
            pickData['FridayAutoOrder'] = this.checked;
        });

        $(document).on('change', '[name="ThursdayAutoOrder"]', function () {
            pickData['ThursdayAutoOrder'] = this.checked;
        });

        $(document).on('change', '[name="WednesdayAutoOrder"]', function () {
            pickData['WednesdayAutoOrder'] = this.checked;
        });

        $(document).on('change', '[name="TuesdayAutoOrder"]', function () {
            pickData['TuesdayAutoOrder'] = this.checked;
        });

        $(document).on('change', '[name="MondayAutoOrder"]', function () {
            pickData['MondayAutoOrder'] = this.checked;
        });

        $(document).on('select2:select', '[name="cityWarehouseId"]', function (event) {
            var selectElement = event.target;
            var value = selectElement.value;
            setWarehouses(value);
        });

        $(document).on('change', '[name="places"]', function () {
            setGeneralParametersByWarehouse($container.find('[name="places"]'), $('.is-active-tariff [name="placesCargoOrder"]'))
        });

        $(document).on('change', '[name="weights"]', function () {
            setGeneralParametersByWarehouse($container.find('[name="weights"]'), $('.is-active-tariff [name="weightCargoOrder"]'))
        });

        $(document).on('change', '[name="volumes"]', function () {
            setGeneralParametersByWarehouse($container.find('[name="volumes"]'), $('.is-active-tariff [name="volumeCargoOrder"]'))
        });

        $(document).on('change', '[name="cost"]', function () {
            setGeneralParametersByWarehouse($container.find('[name="cost"]'), $('[name="declaredCost"]'))
        });
    }

    function getTimeIntervals(date = null, timeProp = null) {
        // $container.addClass('is-loading');
        let url = 'https://delivery-auto.com:8202/api/ReceiptsOpen/GetTimeForOrder';
        let value = $dateOrder.val().split('.');
        value = value[2] + '-' + value[1] + '-' + value[0] + 'T00:00:00';

        $.ajax({
            url: url,
            type: 'get',
            data: {
                orderDate: date ?? value,
                isPick: true,
                timeFrom: timeProp
            },
            success: (response) => {
                let fromMin = response.data.timeFrom.min.substr(11, 5);
                let fromMax = response.data.timeFrom.max.substr(11, 5);
                let toMin = response.data.timeTo.min.substr(11, 5);
                let toMax = response.data.timeTo.max.substr(11, 5);
                let value = $timeFromOrder.find('option:selected').val();
                let timeFrom = [];
                let timeTo = [];
                if (response.data.orderDate) {
                    let date = new Date(response.data.orderDate);
                    $dateOrder.data('daterangepicker').setStartDate(date.toLocaleDateString('uk-UA'));
                    $dateOrder.data('daterangepicker').setEndDate(date.toLocaleDateString('uk-UA'));

                }

                for (let i = 0; i < fromArr.length; i++) {
                    if (fromArr[i].text >= fromMin && fromArr[i].text <= fromMax) {
                        timeFrom.push({
                            'Text': fromArr[i].text,
                            'Value': fromArr[i].value
                        });
                    }
                }
                let timeListFrom = timeFrom.map((item, index) => {
                    return (`<option value="${item['Value']}">${item['Text']}</option>`)
                });
                $timeFromOrder.html(timeListFrom);
                $timeFromOrder.val(value);
                if (timeProp == null)
                    $timeFromOrder.val(null);
                $timeFromOrder.trigger('change');

                for (let i = 0; i < toArr.length; i++) {
                    if (toArr[i].text >= toMin && toArr[i].text <= toMax) {
                        timeTo.push({
                            'Text': toArr[i].text,
                            'Value': toArr[i].value
                        });
                    }
                }
                let timeListTo = timeTo.map((item, index) => {
                    return (`<option value="${item['Value']}">${item['Text']}</option>`)
                });
                $timeToOrder.html(timeListTo);
                $timeToOrder.val(null);
                $timeToOrder.trigger('change');
                // $container.removeClass('is-loading');
            }
        });
    }


    function setTariffData($currentTemplate) {
        let data = {};

        const typeCargo = $currentTemplate.find('[name="typeCargo"]').val();
        const type = typeCargo === "pallets" ? 'pallets' : 'cargo';

        switch (type) {
            default:
            case 'cargo' :
                data = {
                    "places": $currentTemplate.find('[name="placesCargoOrder"]').val(),
                    "weight": $currentTemplate.find('[name="weightCargoOrder"]').val(),
                    "volume": $currentTemplate.find('[name="volumeCargoOrder"]').val(),
                    "CargoTariff": $currentTemplate.find('[name="typeCargo"] option:selected').text(),
                    "isNegabarit": $currentTemplate.find('[name="negabarit"]').prop('checked'),
                    "NeedAdditionalAutoCheck": $currentTemplate.find('[name="needAdditionalAutoCheck"]').prop('checked'),
                    "AdditionalPackingOrderCheck": $currentTemplate.find('[name="additionalPackingOrderCheck"]').prop('checked'),
                    "AdditionalComment": $currentTemplate.find('[name="additionalComment"]').val(),
                }
                break;
            case 'pallets' :
                data = {
                    "places": pickUpSum['tariffCost']['places'],
                    "weight":  pickUpSum['tariffCost']['weight'],
                    "CargoTariff": $currentTemplate.find('[name="palleteType"] option:selected').text(),
                    "palletId": pickUpSum['tariffCost']['palletId'],
                    "isPick": true,
                    "cityId":  pickUpSum['tariffCost']['cityId'],
                    "cost": 0,
                    "isNegabarit": false,
                    "hydroB": false,
                    "needAuto": false,
                    "numReceipts": 0,
                    "volume": 0
                }
                break;
        }
        return data;
    }

    function updateTariffInfo($currentTemplate, data) {
        const $currentTemplateCollapsed = $currentTemplate.find('[data-tariff-collapsed]');
        $currentTemplate.removeClass('is-active-tariff is-editable');
        $currentTemplate.addClass('saved');
        $currentTemplate.find('[data-tariff-form]').addClass('_hide');
        $currentTemplateCollapsed.find('[data-cargo-tariff]').text(data['CargoTariff']);
        $currentTemplateCollapsed.find('[data-cargo-tariff-place]').text(data['places'] + ' ' + declOfNum(data['places'], translates.places));
        $currentTemplateCollapsed.find('[data-cargo-tariff-weight]').text((data['weight'] ? data['weight'] : '0.01') + ' ' + translates.weight);
        $currentTemplateCollapsed.find('[data-cargo-tariff-volume]').text((data['volume'] ? data['volume'] : '0.01') + ' ' + translates.volume);
        $currentTemplateCollapsed.find('[data-cargo-tariff-comment]').text(data['AdditionalComment']);
        if(data['isNegabarit'] === true) {
            $currentTemplateCollapsed.find('[data-cargo-tariff-negabarit]').removeClass('_hide');
        } else {
            $currentTemplateCollapsed.find('[data-cargo-tariff-negabarit]').addClass('_hide');
        }
        if(data['AdditionalPackingOrderCheck'] === true) {
            $currentTemplateCollapsed.find('[data-cargo-tariff-addpack]').removeClass('_hide');
        } else {
            $currentTemplateCollapsed.find('[data-cargo-tariff-addpack]').addClass('_hide');
            $currentTemplateCollapsed.find('[data-cargo-tariff-comment]').text('');
        }
        if(data['NeedAdditionalAutoCheck'] === true) {
            $currentTemplateCollapsed.find('[data-cargo-tariff-auto]').removeClass('_hide');
        }else {
            $currentTemplateCollapsed.find('[data-cargo-tariff-auto]').addClass('_hide');
        }

        $currentTemplateCollapsed.removeClass('_hide');
        $currentTemplate.data('tariff', data);
    }

    function setWarehouseData($currentTemplate) {
        let data = {};
        
        data = {
            "cityWarehouseId": $currentTemplate.find('[name="cityWarehouseId"] option:selected').val(),
            "cityWarehouseName": $currentTemplate.find('[name="cityWarehouseId"] option:selected').text(),
            "warehouseId": $currentTemplate.find('[name="warehouseId"] option:selected').val(),
            "warehouseName": $currentTemplate.find('[name="warehouseId"] option:selected').text(),
            "username": $currentTemplate.find('[name="username"]').val(),
            "places": $currentTemplate.find('[name="places"]').val(),
            "weights": $currentTemplate.find('[name="weights"]').val(),
            "phone": $currentTemplate.find('[name="phoneRecipient"]').val(),
            "volumes": $currentTemplate.find('[name="volumes"]').val(),
            "comment": $currentTemplate.find('[name="comment"]').val(),
            "address": $currentTemplate.find('[name="address"]').val(),
            "generalNotes": $currentTemplate.find('[name="generalNotes"]').val(),
            // "done": $currentTemplate.find('[name="done"]').prop('checked'),
            "additionalPackComment": $currentTemplate.find('[name="additionalPackComment"]').val(),
            "cost": $currentTemplate.find('[name="cost"]').val(),
            "payer": $currentTemplate.find('[name="payer"]').val(),
            "payer_type": $currentTemplate.find('[name="payerType"]:checked').val(),
            "pay_type": $currentTemplate.find('[name="payType"]:checked').val(),
            "delivery": $currentTemplate.find('[name="delivery"]').prop('checked'),
            "hydro": $currentTemplate.find('[name="hydro"]').prop('checked'),
        }
        return data;
    }

    function updateWarehouseInfo($currentTemplate, data) {
        const $currentTemplateCollapsed = $currentTemplate.find('[data-warehouse-collapsed]');
        $currentTemplate.removeClass('is-active-warehouse is-editable');
        $currentTemplate.addClass('saved');
        $currentTemplate.find('[data-warehouse-form]').addClass('_hide');
        $currentTemplateCollapsed.find('[data-warehouse-receiving]').text(data['warehouseName']);
        $currentTemplateCollapsed.find('[data-warehouse-phone]').text(data['phone']);
        $currentTemplateCollapsed.find('[data-warehouse-volume]').text(data['volumes']);
        $currentTemplateCollapsed.find('[data-warehouse-phone]').text(data['']);
        $currentTemplateCollapsed.find('[data-warehouse-sum]').text(data['cost']);
        $currentTemplateCollapsed.find('[data-receiving]').text(data['username']);
        $currentTemplateCollapsed.find('[data-warehouse-place]').text(data['places']);
        $currentTemplateCollapsed.find('[data-warehouse-weight]').text(data['weights']);
        $currentTemplateCollapsed.find('[data-warehouse-address]').text(data['address']);
        $currentTemplateCollapsed.find('[data-warehouse-comment]').text(data['additionalPackComment']);
        $currentTemplateCollapsed.find('[data-warehouse-notes]').text(data['generalNotes']);

        if(data['pay_type'] !== '0') {
            $currentTemplateCollapsed.find('[data-warehouse-paytype]').text(translates.cashlessPayment);
        } else {
            $currentTemplateCollapsed.find('[data-warehouse-paytype]').text(translates.cashPayment);
        }

        if(data['payer_type'] === '0') {
            $currentTemplateCollapsed.find('[data-warehouse-payer]').text(translates.sender);
        } else if (data['payer_type'] === '1') {
            $currentTemplateCollapsed.find('[data-warehouse-payer]').text(translates.resiver);
        } else if (data['payer_type'] === '2') {
            $currentTemplateCollapsed.find('[data-warehouse-payer]').text(translates.thirdPerson +'/' + data['payer']);
        }

        if(data['delivery'] === true) {
            $currentTemplateCollapsed.find('[data-warehouse-delivery]').removeClass('_hide');
        } else {
            $currentTemplateCollapsed.find('[data-warehouse-delivery]').addClass('_hide');
        }

        if(data['hydro'] === true) {
            $currentTemplateCollapsed.find('[data-warehouse-hydro]').removeClass('_hide');
        } else {
            $currentTemplateCollapsed.find('[data-warehouse-hydro]').addClass('_hide');
        }

        $currentTemplateCollapsed.removeClass('_hide');
        $currentTemplate.data('warehouse', data);
    }

    function setWarehouseParametersByGeneral($currentTemplate) {
        const $containerTariff = $('[data-warehouse-wrapper]');
        if ($containerTariff.children().length == 1) {
            let weightsForm = $currentTemplate.find('[name="weights"]');
            weightsForm.val($('.is-active-tariff [name="weightCargoOrder"]').val());
            setParentDivHasValue(weightsForm);
            
            let volumesForm = $currentTemplate.find('[name="volumes"]');
            let volume = $('.is-active-tariff [name="volumeCargoOrder"]').val();
            volume = volume.replace('.', ',');
            volumesForm.val(volume);
            setParentDivHasValue(volumesForm);
            
            let placesForm = $currentTemplate.find('[name="places"]');
            placesForm.val($('.is-active-tariff [name="placesCargoOrder"]').val());
            setParentDivHasValue(placesForm);
            
            let costForm = $currentTemplate.find('[name="cost"]');
            costForm.val($('[name="declaredCost"]').val());
            setParentDivHasValue(costForm);
        }
    }

    function setParentDivHasValue(elem) {
        let formItem = elem.parent().parent();
        formItem.addClass('form-item--has-value');
    }

    function setGeneralParametersByWarehouse($inputContent, $generalInput) {
        let sumPlaces = 0;
        $inputContent.map((item, index) => {
            let places = parseFloat(index['value'].replace(',', '.'));
            if (Number.isNaN(places))
                places = 0;
            sumPlaces += places;
        });
        if (sumPlaces > 0)
            $generalInput.val(sumPlaces);
    }

    function getPickUp() {
        let data = {};
        let URLParams = new URLSearchParams(window.location.href.split('?')[1]);
        if (URLParams.get('appNumber')) {
            data = {
                'appNumber': URLParams.get('appNumber')
            }
        }
        $.ajax({
            url: '/' + window.currentLang + '/SharedForms/GetPickUpInit',
            type: 'get',
            data: data,
            success: (response) => {
                const $currentPlace = $('.is-active-tariff');
                // let data = response['CityList'].map((item) => {
                //     if (item['Text'] !== '') {
                //         return (`<option value="${item['Value']}">${item['Text']}</option>`)
                //     }
                // });
                // $cityId.html(data);
                // $cityId.val(null);
                // $cityWarehouseId.html(data);
                // $cityWarehouseId.val(null);

                if (response['CityId'] !== '00000000-0000-0000-0000-000000000000' && response['CityId'] && response['CityName'] !== null) {
                    let $cityOption = new Option(response['CityName'], response['CityId'], false, false);
                    $cityId.append($cityOption).trigger('select2:select');
                }

                let timeList = response['TimeList'].map((item, index) => {
                    if (item['Text'] !== '') {
                        return (`<option id="${index}" value="${item['Value']}">${item['Text']}</option>`)
                    }
                });
                $timeFromOrder.html(timeList);
                $timeFromOrder.val(null);
                $timeToOrder.html(timeList);
                $timeToOrder.val(null);
                fromArr = $container.find('[name="timeFromOrder"] option');
                toArr = $container.find('[name="timeToOrder"] option');

                $organizationNameOrder.val(response['OrganizationNameOrder']).trigger('change');
                $emailOrder.val(response['EmailOrder']).trigger('change');
                if (response['ContactPersonOrder'] != null)
                    $contactPersonOrder.val(response['ContactPersonOrder']).trigger('change');
                if (response['ContactPhoneOrder'] != null)
                    $contactPhoneOrder.val(response['ContactPhoneOrder']).trigger('change');
                if (response['AddressOrder'] !== null) {
                    $addressOrder.val(response['AddressOrder']).trigger('change');
                }
                if (response['PlacesCargoOrder'] !== null && response['WeightCargoOrder'] !== null && response['VolumeCargoOrder'] !== null) {
                    if (response['IsPallet']) {
                        $currentPlace.find('select').val('pallets').trigger('select2:select');
                    } else {
                        $currentPlace.find('select').val('cargo').trigger('select2:select');
                    }
                    $currentPlace.find('[name="placesCargoOrder"]').val(response['PlacesCargoOrder']).trigger('change');
                    $currentPlace.find('[name="weightCargoOrder"]').val(response['WeightCargoOrder']).trigger('change');
                    $currentPlace.find('[name="volumeCargoOrder"]').val(response['VolumeCargoOrder']).trigger('change');

                    $currentPlace.find('[name="additionalPackingOrderCheck"]').prop('checked', response['AdditionalPackingOrderCheck']).trigger('change');
                    $currentPlace.find('[name="needAdditionalAutoCheck"]').prop('checked', response['NeedAdditionalAutoCheck']).trigger('change');
                    $currentPlace.find('[name="negabarit"]').prop('checked', response['CargoSizeOrderCheck']).trigger('change');

                }
                let date = new Date();

                let formattedDate = `${date.toLocaleDateString('fr-CA')}T${date.toLocaleTimeString()}`;
                getTimeIntervals(formattedDate);
            }
        })
    }

    function setButtonsState() {
        const $inputs = $('[data-tabs-block="step1"]').find( 'input, select').filter('[data-fields]');
        const $calculateButton = $('[data-pick-sum]');
        const $createPick = $('[data-create-pick]');
        const $step2 = $('.warn-block').find('[data-tabs-button="step2"]');
        if ($inputs.length > 0) {
            const inputsHasValue = $inputs.filter(function () {
                return $.trim($(this).val()).length === 0
            }).length === 0;
            const tariffsLength = $wrapper.children().filter('.is-valid').length;

            if(inputsHasValue && tariffsLength > 0 ) {
                $calculateButton.removeClass('disabled');
                // $createPick.removeClass('disabled');
                $step2.removeClass('disabled');
            } else {
                $calculateButton.addClass('disabled');
                // $createPick.addClass('disabled');
                $step2.addClass('disabled');
            }
        }
    }

    function setButtonsStateStep2() {
        const $createPickStep2 = $('[data-create-pick-step2]');
        const warehouse = $('[data-warehouse-wrapper]').children().filter('.saved').length;

        if( warehouse > 0 ) {
            $createPickStep2.removeClass('disabled');
        } else {
            $createPickStep2.removeClass('disabled');
        }
    }

    function eventsCargo() {
        $(document).on('select2:select', '.is-active-tariff [name="typeCargo"]', function () {
            const typeCargo = $('.is-active-tariff').find('[name="typeCargo"] option:selected').val();

            switch (typeCargo) {
                case 'null':
                    $('.is-active-tariff').find('[data-type-cargo]').addClass('_hide');
                    $('.is-active-tariff').find('[data-type-pallets]').addClass('_hide');
                    return false;
                case 'cargo':
                    $('.is-active-tariff').find('[data-type-cargo]').removeClass('_hide');
                    $('.is-active-tariff').find('[data-type-pallets]').addClass('_hide');
                    $('.is-active-tariff').find('[data-type-pallets]').find('input, select').attr('disabled', true);
                    $('.is-active-tariff').find('[data-type-cargo]').find('input, select').attr('disabled', false);
                    break;
                case 'pallets':
                    $('.is-active-tariff').find('[data-type-cargo]').addClass('_hide');
                    $('.is-active-tariff').find('[data-type-pallets]').removeClass('_hide');
                    $('.is-active-tariff').find('[data-type-pallets]').find('input, select').attr('disabled', false);
                    $('.is-active-tariff').find('[data-type-cargo]').find('input, select').attr('disabled', true);
                    break;
            }
        });

        $(document).on('change', '.is-active-tariff [name="weightPalletsOrder"]', function () {
            let palletsLimitMax = 1250;
            let palletsLimitMin = 80;

            if (this.value > palletsLimitMax) {
                notifier.error(translates.weightPalletsLimitMax).then((noty) => {
                    noty.show();
                });
                $('.is-active-tariff [name="weightPalletsOrder"]').val(palletsLimitMax);
            } else if (this.value < palletsLimitMin) {
                notifier.error(translates.weightPalletsLimitMin).then((noty) => {
                    noty.show();
                });
                $('.is-active-tariff [name="weightPalletsOrder"]').val(palletsLimitMin);
            }
            this.value  > limitWeight ? $economyPickUp.prop('checked', false).prop('disabled', true) : $economyPickUp.prop('disabled', false);
        });

        $(document).on('change', $('.is-active-tariff').find('input, select'), function () {
            const $currentTemplate = $('.is-active-tariff');
            const $addTariffButton = $currentTemplate.find('[data-add-tariff]');
            const $tariffCheck = $currentTemplate.find('[data-tariff-check]');
            let isValid;

            if ($typeCargo.val() === null) {
                isValid = false;
                $addTariffButton.removeClass('is-active');
            }

            const inputs = $currentTemplate.find('input:not(:disabled), select:not(:disabled)').filter('[data-required]');
            if (inputs.length > 0) {
                isValid = inputs.filter(function () {
                    return $.trim($(this).val()).length === 0
                }).length === 0;

                if (isValid ) {
                    $addTariffButton.removeClass('disabled').addClass('is-active');
                    $tariffCheck.removeClass('_hide');
                    $currentTemplate.addClass('is-valid');
                    const data = setTariffData($currentTemplate);
                    $currentTemplate.data('tariff', data);
                    setButtonsState();
                } else {
                    $addTariffButton.addClass('disabled').removeClass('is-active');
                    $tariffCheck.addClass('_hide');
                    $currentTemplate.removeClass('is-valid');
                    $currentTemplate.removeClass('is-valid');

                }
            }
        });
    }

    function setWarehouses($cityId) {
        //const $selected = $cityWarehouseId.find('option:selected');
        //if ($selected.length > 0) {
            $.ajax({
                url: '/api/Calculation/GetWarehousesListByAreasReceipt',
                type: 'get',
                data: {
                    culture: window.currentLang,
                    'AreasId': $cityId,/*$selected.val(),*/
                },
                success: (response) => {
                    let data = response.map((item, index) => {
                        if (item.name !== '') {
                            return (`<option value="${item.id}">${item.name}</option>`)
                        }
                    })

                    $container.find('.is-active-warehouse [name="warehouseId"]').html(data);
                    $container.find('.is-active-warehouse [name="warehouseId"]').trigger('select2:select');
                }
            });
        //}
    }

    function createPickUp(secondStep = false) {
        let $inputs;
        const $tariffItems = $(element).find('[data-tariff-item].is-valid');

        if (secondStep) {
            $inputs = $('[data-tabs-block="step2"]').find( 'input, select').filter('[data-fields]');
        } else {
            $inputs = $('[data-tabs-block="step1"]').find( 'input, select').filter('[data-fields]');
        }

        const valid = validate($inputs, true, secondStep);

        if (valid ) {
            $tariffItems.each((i, el) => {
                const $el = $(el);
                listPallets.push($el.data('tariff').CargoTariff + ' - ' + $el.data('tariff').places + ' - ' + $el.data('tariff').weight );
                pickData['PalletComment'] = listPallets.join(';');
            });

            const $warehouseList = $(element).find('[data-warehouse-item].is-valid');
            $warehouseList.each((i, el) => {
                pickData['pickUpCargoExtended'].push($(el).data('warehouse'));
            });
            $body.addClass('is-loading');
            $.ajax({
                url: '/' + window.currentLang + '/SharedForms/PickHyper',
                type: 'post',
                data: pickData,
                success: (response) => {
                    $body.removeClass('is-loading');
                    if (response['status']) {
                        $('[data-receipt-number]').text(response['receptNumber']);
                        //pickData['documentsStr'] = null;
                        //pickData['documentsName'] = null;
                        magnificPopup.open({
                            items: {
                                src: '#applicationSent'
                            },
                            type: 'inline'
                        });
                    } else {
                        notifier.error(response['message']).then((noty) => {
                            noty.show();
                        });
                    }
                }
            })
        }
    }

    function pickUpCost() {
        let palletInput = [];

        const $tariffList = $(element).find('[data-tariff-item].is-valid');
        let type = $('.is-active-tariff').find('[name="typeCargo"] option:selected').val();

        if(type === 'pallets') {
            $tariffList.each((i, el) => {
                palletInput.push($(el).data('tariff'));
            });
        }

        let tariffCount = $wrapper.find('.is-valid');

        let data = [{
            weight: pickUpSum['tariffCost']['weight'],
            volume: pickUpSum['tariffCost']['volume'],
            places: pickUpSum['tariffCost']['places'],
            palletId: null,
            cityId: $cityId.find('option:selected').val(),
            cost: 0,
            tarifName: null,
            isNegabarit: $negabarit.prop('checked'),
            needAuto: $needAuto.prop('checked'),
            isPick: pickUpSum['tariffCost']['isPick'],
            hydroB: false,
            numReceipts: tariffCount.length
        }];

        $.ajax({
            url: '/' + window.currentLang + '/SharedForms/GetTarifCost',
            type: 'post',
            data: { model: $typeCargo.val() === 'cargo' ? data : palletInput },
            success: (response) => {
                $totalSum.text('');
                $totalSum.text(response['totalSum']);
            }
        })
    }

    function eventsWarehouse() {
        $(document).on('change', $('.is-active-warehouse').find('input, select'), function () {
            const $currentTemplate = $('.is-active-warehouse')
            const $addWarehouseButton = $currentTemplate.find('[data-warehouse-add]');
            const $warehouseCheck = $currentTemplate.find('[data-warehouse-check]');
            let isValid;

            const inputs = $currentTemplate.find('input, select').filter('[data-required]');

            if (inputs.length > 0) {
                isValid = inputs.filter(function () {
                    return $.trim($(this).val()).length === 0
                }).length === 0;

                if (isValid) {
                    $addWarehouseButton.removeClass('disabled').addClass('is-active');
                    $warehouseCheck.removeClass('_hide');
                    $currentTemplate.addClass('is-valid saved');
                    const data = setWarehouseData($currentTemplate);
                    $currentTemplate.data('warehouse', data);
                    setButtonsStateStep2();
                } else {
                    $addWarehouseButton.addClass('disabled').removeClass('is-active');
                    $warehouseCheck.addClass('_hide');
                    $currentTemplate.removeClass('is-valid saved');
                }
                setButtonsStateStep2();
            }
        });
    }

    function HasWarehouseInCity(cityId) {
        $.ajax({
            url: '/api/v4/Public/GetWarehousesList',
            type: 'get',
            data: {
                culture: window.currentLang,
                'CityId': cityId
            },
            success: (response) => {
                if (response.data.length > 0)
                    $("#warning-cost-delivery").addClass('_hide');
                else
                    $("#warning-cost-delivery").removeClass('_hide');
            }
        });
    }

    function validate ($inputs, checkPlaces = false, secondStep = false) {
        const $allInputs = $('[data-fields]');
        let $places;
        if (secondStep) {
            $places = $(element).find('[data-warehouse-item].is-valid');
        } else {
            $places = $(element).find('[data-tariff-item].is-valid');
        }
        const $emptyInputs = $inputs.filter(function () {
            return $.trim($(this).val()).length === 0
        });
        const inputsHasValue = $emptyInputs.length === 0;
        const hasValidPlaces = $places.length !== 0;

        $allInputs.parents('.form-item').removeClass('invalid');

        if (!inputsHasValue) {
            $emptyInputs.parents('.form-item').addClass('invalid')
        }
        if (!hasValidPlaces) {
            $(element).find('.is-active-tariff').addClass('invalid');
        } else {
            $(element).find('.is-active-tariff').removeClass('invalid');
        }

        return inputsHasValue && hasValidPlaces;
    }

    getPickUp();
    setEvents();
    eventsCargo();
    eventsWarehouse();
}

export default function (element) {
    init(element);
}